import React, { useEffect, useState } from 'react';
import { Onboarding } from './components/Onboarding';
import { Hero } from './components/Hero';
import { WhoWeAre } from './components/WhoWeAre';
import { WhatWeDo } from './components/WhatWeDo';
import { WhySmall } from './components/WhySmall';
import { MarketFocus } from './components/MarketFocus';
import { HowDifferent } from './components/HowDifferent';
import { ShowDontTell } from './components/ShowDontTell';
import { QuantVisualizations } from './components/QuantVisualizations';
import { LiveMarketData } from './components/LiveMarketData';
import { JoinUs } from './components/JoinUs';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  const [showOnboarding, setShowOnboarding] = useState(true);
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    const onboardingComplete = localStorage.getItem('periclesOnboardingComplete');
    if (onboardingComplete === 'true') {
      setShowOnboarding(false);
      setIsReady(true);
    }
  }, []);
  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    setTimeout(() => setIsReady(true), 100);
  };
  if (showOnboarding) {
    return <Onboarding onComplete={handleOnboardingComplete} data-id="element-0" />;
  }
  if (!isReady) {
    return null;
  }
  return <div className="w-full min-h-screen bg-navy-900 text-white" data-id="element-1">
      <Hero data-id="element-2" />
      <WhoWeAre data-id="element-3" />
      <WhatWeDo data-id="element-4" />
      <WhySmall data-id="element-5" />
      <MarketFocus data-id="element-6" />
      <HowDifferent data-id="element-7" />
      <ShowDontTell data-id="element-8" />
      <QuantVisualizations data-id="element-9" />
      <LiveMarketData data-id="element-10" />
      <JoinUs data-id="element-11" />
      <FAQ data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}